// A tiny store the update prompt subscribes to. The new service worker waits until the player says reload,
// so a version switch never interrupts a reveal. Apart from register.ts so the prompt (in the first load)
// doesn't bring the registration code, which loads after the first render.

type Listener = () => void;
const listeners = new Set<Listener>();
let needRefresh = false;
let update: ((reload?: boolean) => Promise<void>) | undefined;

function emit() {
  for (const listener of listeners) listener();
}

export const pwaUpdate = {
  subscribe: (listener: Listener) => {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },
  needRefresh: () => needRefresh,
  async apply() {
    await update?.(true);
  },
  dismiss() {
    needRefresh = false;
    emit();
  },
};

/** Called by register.ts: how to switch to the waiting version. */
export function setUpdater(updater: (reload?: boolean) => Promise<void>) {
  update = updater;
}

/** Called by register.ts when a new version is waiting. */
export function markNeedRefresh() {
  needRefresh = true;
  emit();
}
